var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrownRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26953 4.80794L1.81215 1.09346C1.29109 0.659238 0.5 1.02976 0.5 1.70803L0.5 8.29197C0.5 8.97024 1.29108 9.34076 1.81215 8.90654L6.26953 5.19206C6.38947 5.09211 6.38947 4.90789 6.26953 4.80794Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrownRightWhite);
export default __webpack_public_path__ + "static/media/arrown-right-white.d96a6016a75d112ca3da88f8a6b43025.svg";
export { ForwardRef as ReactComponent };